import React, {Component} from "react";
import {Link} from "react-router-dom";
import SixgillLogo from '../../theme/bitsight_logo_white.png';

export default class SupportMain extends Component {
    render() {
        const {match} = this.props
        const base_url_for_links = match.url.replace(/\/$/, "")
        return (
            <div className="SupportMainPage">
                <div className="support-full-header">
                    <div className="breadcrumbs">
                        <span className="breadcrumb active">Support</span>
                    </div>
                    <h1>How can we help you?</h1>
                </div>
                <div className="support-content full-width">
                    <div className="support-main-page-links">
                        <div className="support-main-section">
                            <div className="support-main-section-header documentation">
                                Documentation
                            </div>
                            <a href={`${process.env.PUBLIC_URL}/documents/Bitsight CTI API User Guide.pdf`} target="_blank">Bitsight CTI API V2 user guide</a>
                            <a href={`${process.env.PUBLIC_URL}/documents/Bitsight CTI API V3 User Guide.pdf`} target="_blank">Bitsight CTI API V3 user guide</a>
                            <a href={`${process.env.REACT_APP_BITSIGHT_URL}/sixgill-api-restrictions/`} target="_blank">Restrictions on Scope and Use of the API</a>
                        </div>
                    </div>
                    <div className="support-footer">
                        <img src={SixgillLogo} alt="sixgill"/>
                    </div>
                </div>

            </div>
        )
    }
}